import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import type { AppState } from '~/reducers';
import { useIsAndroidOrIOS } from '~/core/hooks/use-is-android-ios-device';
import { hasWebViewHost } from '~/domain/native/utils/has-webview-host';
import { InternationalizationNameSpace } from '~/constants/internationalization-namespace';
import URLS from '~/constants/urls';
import { useInstallBannerDismissal } from '../../hooks/use-install-banner-dismissal';
import { useIsSignupRoute } from '../../hooks/use-is-signup-route';
import AppInstallBanner from '../AppInstallBanner/AppInstallBanner';

const IOSInstallBanner = () => {
  const { t } = useTranslation([InternationalizationNameSpace.InstallPrompt], {
    useSuspense: false,
  });
  const onWebView = useSelector((state: AppState) => state.native.onWebView);
  const { isIOS } = useIsAndroidOrIOS();
  const { dismissed, dismiss } = useInstallBannerDismissal();
  const isSignupRoute = useIsSignupRoute();

  if (hasWebViewHost()) {
    return null;
  }
  if (onWebView) {
    return null;
  }
  if (!isIOS) {
    return null;
  }
  if (isSignupRoute) {
    return null;
  }
  if (dismissed) {
    return null;
  }

  return (
    <AppInstallBanner
      testId="ios-install-banner"
      storeLabel={t('iosBanner.store')}
      ctaLabel={t('androidBanner.cta')}
      ctaUrl={URLS.APPLE_APP_STORE_URL}
      title={t('androidBanner.title')}
      publisher={t('androidBanner.publisher')}
      dismissAriaLabel={t('androidBanner.dismissAriaLabel')}
      appIconAlt={t('androidBanner.appIconAlt')}
      onDismiss={dismiss}
    />
  );
};

export default IOSInstallBanner;
